<template>
  <span v-if="loadingCase" title="Loading assignee">
    <i class="far fa-fw fa-pulse fa-spinner" aria-hidden="true"></i>
  </span>
  <span v-else>{{ assignedToInitials || '--' }}</span>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: {
    patient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assignedToInitials: '',
      loadingCase: false,
    }
  },
  computed: {
    ...mapGetters(['custom_claims']),
    customerId() {
      return this.custom_claims?.customerId || null
    },
    locationId() {
      return this.custom_claims?.authorized_location || null
    },
    activeCasePath() {
      if (!this.customerId || !this.locationId || !this.patient.id || !this.patient.activeCaseId) {
        return null
      }

      return `customers/${this.customerId}/locations/${this.locationId}/patients/${this.patient.id}/cases/${this.patient.activeCaseId}`
    },
  },
  watch: {
    activeCasePath: {
      immediate: true,
      async handler(path) {
        this.assignedToInitials = ''
        this.loadingCase = Boolean(path)

        if (!path) {
          return
        }

        try {
          const doc = await Vue.firestore.doc(path).get()
          if (this.activeCasePath === path && doc.exists) {
            this.assignedToInitials = doc.data()?.assignedToInitials || ''
          }
        } catch (err) {
          console.error('Failed to load active patient case:', err)
        } finally {
          if (this.activeCasePath === path) {
            this.loadingCase = false
          }
        }
      },
    },
  },
}
</script>